import { render, staticRenderFns } from "./InformationIncident.vue?vue&type=template&id=0fb8dfb3&scoped=true"
import script from "./InformationIncident.vue?vue&type=script&lang=js"
export * from "./InformationIncident.vue?vue&type=script&lang=js"
import style0 from "./InformationIncident.vue?vue&type=style&index=0&id=0fb8dfb3&prod&scoped=true&lang=css"
import style1 from "./InformationIncident.vue?vue&type=style&index=1&id=0fb8dfb3&prod&lang=css"
import style2 from "./InformationIncident.vue?vue&type=style&index=2&id=0fb8dfb3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb8dfb3",
  null
  
)

export default component.exports